import { render, staticRenderFns } from "./SlyshKupi.vue?vue&type=template&id=569e1b7c&lang=html"
import script from "./SlyshKupi.vue?vue&type=script&lang=js"
export * from "./SlyshKupi.vue?vue&type=script&lang=js"
import style0 from "./SlyshKupi.vue?vue&type=style&index=0&id=569e1b7c&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports